import React from 'react';

export const GANTT_ZOOMS = ['week', 'month', 'quarter'];

/**
 * THE zoom control of a Gantt's own header strip: Week | Month | Quarter as one
 * joined, bordered group, the active one solid blue. One component so the
 * charts cannot drift (owner 2026-10-13, having settled the Breakdown
 * Timeline's strip: "use these changes as our defaults for all gantt charts
 * where common features exist"). Before it the Labour view drew loose text
 * buttons and four charts each carried their own copy of this markup.
 *
 *   zoom          the current zoom
 *   onZoom(z)     pass the chart's `zoomTo` (`hooks/useZoomKeepsCentre`), never
 *                 a bare `setZoom`: that is what keeps the centre date in place
 *   testIdPrefix  optional; each button gets `${testIdPrefix}-${z}`
 *
 * No visible "Zoom" caption: the three words say it, and the caption cost a
 * strip its single line. The group carries the name for assistive technology,
 * and `aria-pressed` carries the active one, so colour is not the only signal.
 *
 * 🔴 NOT for a control portalled into a PAGE toolbar (the Budget Labour Flow):
 * that one sits beside `ui/Toolbar` segments and takes their style.
 */
export default function GanttZoomControl({ zoom, onZoom, testIdPrefix }) {
  return (
    <div role="group" aria-label="Zoom" className="inline-flex rounded-lg border border-gray-300 dark:border-gray-600 overflow-hidden">
      {GANTT_ZOOMS.map((z) => (
        <button
          key={z} type="button"
          aria-pressed={zoom === z}
          onClick={() => onZoom(z)}
          data-testid={testIdPrefix ? `${testIdPrefix}-${z}` : undefined}
          className={`px-3 py-1.5 text-xs font-medium capitalize transition-colors ${
            zoom === z
              ? 'bg-blue-600 dark:bg-blue-500/70 text-white'
              : 'bg-white dark:bg-gray-700 text-gray-600 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-600'
          }`}
        >
          {z}
        </button>
      ))}
    </div>
  );
}
